//const url = 'https://script.google.com/macros/s/AKfycbyWg6scrVPuZ0ssiyoOKX_M-ERY9OH6dlNKuk2gY69O1V5No462PT0SVj7d2fXR5OM/exec';

 const url = 'https://img.billy.pet/reviews/?type=review';
 
function parseReviews(data, limit) {
  const lines = data.trim().split('\n').slice(1, limit + 1);
  const reviews = lines.map(line => {
    const [productHandle, rating, author, country, content, commentedAt, photoUrl] = line.split(',');
    return {
      productHandle,
      rating: parseInt(rating, 10),
      author,
      country,
      content,
      commentedAt: new Date(commentedAt),
      photoUrl
    };
  });
  return reviews;
}
function formatCommentedAt(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  if (diffDays > 30) {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } else if (diffDays > 0) {
    return `${diffDays} days ago`;
  } else if (diffHours > 0) {
    return `${diffHours} hours ago`;
  } else {
    return `${diffMinutes} minutes ago`;
  }
}

   function formatNumberWithK(number) {
      if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K';
      } else {
        return number.toString();
      }
    } 

 const reviewsCountSpan = document.querySelector('.reviewsCountArea .reviewsCount');
function totalReviewCount(){
  
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Check the number of items in the JSON data
        const numberOfItems = data.length;
    
        if (numberOfItems === 0) {
          console.log('No data found.');
          return;
        }
    
        // Calculate the total rating and average rating
        let totalRating = 0;
    
        data.forEach(item => {
          if (item.hasOwnProperty('rating') ) {
            totalRating += parseFloat(item.rating);
          }
        });
      
        const totalReviews = formatNumberWithK(numberOfItems);
        const averageRating = (totalRating / numberOfItems).toFixed(2);
        var rating = parseFloat(averageRating); 
        var roundedRating = Math.round(rating);
        if(roundedRating > 5 ){
          var roundedRating = 5; 
        }else if(roundedRating < 1){ 
          var roundedRating = 1; 
        } 
        if (reviewsCountSpan) { 
          
            const suffix = reviewsCountSpan.getAttribute('data-suffix');
            reviewsCountSpan.innerHTML = `<img width="132px" src="https://cdn.shopify.com/s/files/1/0414/0312/1832/t/12/assets/${roundedRating}stars.svg">  ${totalReviews} ${suffix}`;
            reviewsCountSpan.setAttribute('title', averageRating);
            reviewsCountSpan.setAttribute('data-rating', averageRating);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
 
}

  if (reviewsCountSpan) {
      totalReviewCount();
  }
      const reviewsEl = document.querySelector('.rash-customer-reviews');
  
if (reviewsEl) {
  const limit = parseInt(reviewsEl.getAttribute('data-limit'), 10);
  fetch(`${url}&limit=${limit}`)
    .then(response => response.json())
    .then(data => { 
      const reviews = data.slice(0, limit);
      const ul = reviewsEl.querySelector('ul');
      ul.innerHTML = '';
      reviews.forEach(review => {
        const li = document.createElement('li');
        
        var rating = parseFloat(review.rating); 
        var roundedRating = Math.round(rating);
        if(roundedRating > 5 ){
          var roundedRating = 5; 
        }else if(roundedRating < 1){ 
          var roundedRating = 1; 
        }
        
        li.innerHTML = `
        <div class="review_inner">
        <div class="auth_thumb">
          <img src="${review.photo_url_1}" alt="${review.author}">
        </div>
       
        <div class="review_content">
         <div class="name_time">
        
          <div class="author">${review.author}</div>
          <div class="commented-at">${formatCommentedAt(review.commented_at)}</div>
          <div class="validiti"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.5599 11.2401L20.1999 9.66006C19.9399 9.36006 19.7299 8.80006 19.7299 8.40006V6.70006C19.7299 5.64006 18.8599 4.77006 17.7999 4.77006H16.0999C15.7099 4.77006 15.1399 4.56006 14.8399 4.30006L13.2599 2.94006C12.5699 2.35006 11.4399 2.35006 10.7399 2.94006L9.16988 4.31006C8.86988 4.56006 8.29988 4.77006 7.90988 4.77006H6.17988C5.11988 4.77006 4.24988 5.64006 4.24988 6.70006V8.41006C4.24988 8.80006 4.03988 9.36006 3.78988 9.66006L2.43988 11.2501C1.85988 11.9401 1.85988 13.0601 2.43988 13.7501L3.78988 15.3401C4.03988 15.6401 4.24988 16.2001 4.24988 16.5901V18.3001C4.24988 19.3601 5.11988 20.2301 6.17988 20.2301H7.90988C8.29988 20.2301 8.86988 20.4401 9.16988 20.7001L10.7499 22.0601C11.4399 22.6501 12.5699 22.6501 13.2699 22.0601L14.8499 20.7001C15.1499 20.4401 15.7099 20.2301 16.1099 20.2301H17.8099C18.8699 20.2301 19.7399 19.3601 19.7399 18.3001V16.6001C19.7399 16.2101 19.9499 15.6401 20.2099 15.3401L21.5699 13.7601C22.1499 13.0701 22.1499 11.9301 21.5599 11.2401ZM16.1599 10.6101L11.3299 15.4401C11.1899 15.5801 10.9999 15.6601 10.7999 15.6601C10.5999 15.6601 10.4099 15.5801 10.2699 15.4401L7.84988 13.0201C7.55988 12.7301 7.55988 12.2501 7.84988 11.9601C8.13988 11.6701 8.61988 11.6701 8.90988 11.9601L10.7999 13.8501L15.0999 9.55006C15.3899 9.26006 15.8699 9.26006 16.1599 9.55006C16.4499 9.84006 16.4499 10.3201 16.1599 10.6101Z" fill="#787F72"/>
</svg>
</div>
        </div>
          <div class="rating" data-rating="${roundedRating}"><img width="132px" src="https://cdn.shopify.com/s/files/1/0414/0312/1832/t/12/assets/${roundedRating}stars.svg"></div>
         
          <div class="content">${review.content}</div>
        </div>
        </div>
        `;
        ul.appendChild(li);
      });
    })
    .catch(error => console.error(error));
}


      /* all reviews */
      
      function generatePagination(currentPage, totalPages) {
        const paginationEl = document.createElement('div');
        paginationEl.classList.add('page-pagination');
      
        const prevPageEl = document.createElement('button');
        prevPageEl.innerHTML = 'Previous';
        if (currentPage === 1) {
          prevPageEl.disabled = true;
        } else {
          prevPageEl.addEventListener('click', () => {
            goToPage(currentPage - 1);
          });
        }
        paginationEl.appendChild(prevPageEl);
      
        const pageNumbers = [];
        if (totalPages <= 5) {
          for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
          }
        } else if (currentPage <= 3) {
          pageNumbers.push(1, 2, 3, 4, '...', totalPages);
        } else if (currentPage >= totalPages - 2) {
          pageNumbers.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        } else {
          pageNumbers.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
        }
      
        pageNumbers.forEach(pageNumber => {
          const pageEl = document.createElement('button');
          pageEl.innerHTML = pageNumber;
          if (pageNumber === '...') {
            pageEl.disabled = true;
          } else if (pageNumber === currentPage) {
            pageEl.classList.add('current-page');
            pageEl.disabled = true;
          } else {
            pageEl.addEventListener('click', () => {
              goToPage(pageNumber);
            });
          }
          paginationEl.appendChild(pageEl);
        });
      
        const nextPageEl = document.createElement('button');
        nextPageEl.innerHTML = 'Next';
        if (currentPage === totalPages) {
          nextPageEl.disabled = true;
        } else {
          nextPageEl.addEventListener('click', () => {
            goToPage(currentPage + 1);
          });
        }
        paginationEl.appendChild(nextPageEl);
      
        return paginationEl;
      }

      const reviewsElall = document.querySelector('.rash-customer-reviews-all');
      const reviewspagination = document.querySelector('.review_pagination');

        if (reviewsElall) {
          const limit = parseInt(reviewsElall.getAttribute('data-limit'), 10);
          let currentPage = 1;
        
          function renderReviews(data) {
            const reviews = data.slice((currentPage - 1) * limit, currentPage * limit);
            const ul = reviewsElall.querySelector('ul');
            ul.innerHTML = '';
            reviews.forEach(review => {
              const li = document.createElement('li');
             
        var rating = parseFloat(review.rating); 
        var roundedRating = Math.round(rating);
           if(roundedRating > 5 ){
          var roundedRating = 5; 
        }else if(roundedRating < 1){ 
          var roundedRating = 1; 
        }    
              li.innerHTML = `
                <div class="review_inner">
                  <div class="auth_thumb">
                       <div class="p_image"><img src="${review.photo_url_1}" alt="${review.author}"></div>
                      <div class="mobile_author small-up-hide">
                        <div class="author  ">${review.author}</div> 
                        <div class="commented-at ">${formatCommentedAt(review.commented_at)}</div>
                      </div>
                  </div>
                  <div class="review_content"> 
                    <div class="author small-hide">${review.author}</div>
                    <div class="content">${review.content}</div>
                  </div>
                  <div class="product_image">  
                    <div class="review_product_image"><img src="${review.product_image}"></div>
                  </div>
                   <div class="name_time">
                      
                  

                      <div class="rating" data-rating="${roundedRating}"><img width="132px" src="https://cdn.shopify.com/s/files/1/0414/0312/1832/t/12/assets/${roundedRating}stars.svg"></div>
                          <div class="validiti">Verified Customer<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.5599 11.2401L20.1999 9.66006C19.9399 9.36006 19.7299 8.80006 19.7299 8.40006V6.70006C19.7299 5.64006 18.8599 4.77006 17.7999 4.77006H16.0999C15.7099 4.77006 15.1399 4.56006 14.8399 4.30006L13.2599 2.94006C12.5699 2.35006 11.4399 2.35006 10.7399 2.94006L9.16988 4.31006C8.86988 4.56006 8.29988 4.77006 7.90988 4.77006H6.17988C5.11988 4.77006 4.24988 5.64006 4.24988 6.70006V8.41006C4.24988 8.80006 4.03988 9.36006 3.78988 9.66006L2.43988 11.2501C1.85988 11.9401 1.85988 13.0601 2.43988 13.7501L3.78988 15.3401C4.03988 15.6401 4.24988 16.2001 4.24988 16.5901V18.3001C4.24988 19.3601 5.11988 20.2301 6.17988 20.2301H7.90988C8.29988 20.2301 8.86988 20.4401 9.16988 20.7001L10.7499 22.0601C11.4399 22.6501 12.5699 22.6501 13.2699 22.0601L14.8499 20.7001C15.1499 20.4401 15.7099 20.2301 16.1099 20.2301H17.8099C18.8699 20.2301 19.7399 19.3601 19.7399 18.3001V16.6001C19.7399 16.2101 19.9499 15.6401 20.2099 15.3401L21.5699 13.7601C22.1499 13.0701 22.1499 11.9301 21.5599 11.2401ZM16.1599 10.6101L11.3299 15.4401C11.1899 15.5801 10.9999 15.6601 10.7999 15.6601C10.5999 15.6601 10.4099 15.5801 10.2699 15.4401L7.84988 13.0201C7.55988 12.7301 7.55988 12.2501 7.84988 11.9601C8.13988 11.6701 8.61988 11.6701 8.90988 11.9601L10.7999 13.8501L15.0999 9.55006C15.3899 9.26006 15.8699 9.26006 16.1599 9.55006C16.4499 9.84006 16.4499 10.3201 16.1599 10.6101Z" fill="#787F72"/>
</svg></div>
                      <div class="commented-at small-hide">${formatCommentedAt(review.commented_at)}</div>
                    </div>
                </div>
              `;
              ul.appendChild(li);
            });
          }
        
          function renderPagination(data) {
            const totalPages = Math.ceil(data.length / limit);
            const paginationEl = reviewspagination;
            const pagesToShow = 5; // The number of page numbers to show (including current page)
            const halfPagesToShow = Math.floor(pagesToShow / 2);
            const firstPage = Math.max(1, currentPage - halfPagesToShow);
            const lastPage = Math.min(currentPage + halfPagesToShow, totalPages);
            
            paginationEl.classList.add('pagination');
            paginationEl.innerHTML = `
              <button class="prev-btn" ${currentPage === 1 ? 'disabled' : ''}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 15.821L7.5 10.821L12.5 5.82104" stroke="#232A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            `;
            
            if (firstPage > 1) {
              paginationEl.innerHTML += `<div class="pages prev1">1</div>`;
              if (firstPage > 2) {
                paginationEl.innerHTML += `<div class="pages ellipsis">...</div>`;
              }
            }
            
            for (let i = firstPage; i <= lastPage; i++) {
              paginationEl.innerHTML += `<div class="pages ${i === currentPage ? 'current' : ''}">${i}</div>`;
            }
            
            if (lastPage < totalPages) {
              if (lastPage < totalPages - 1) {
                paginationEl.innerHTML += `<div class="pages ellipsis">...</div>`;
              }
              paginationEl.innerHTML += `<div class="pages next1">${totalPages}</div>`;
            }
            
            paginationEl.innerHTML += `
              <button class="next-btn" ${currentPage === totalPages ? 'disabled' : ''}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 15.821L12.5 10.821L7.5 5.82104" stroke="#232A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            `;
            
            reviewsElall.appendChild(paginationEl);
                        
            const prevBtn = paginationEl.querySelector('.prev-btn');
            const nextBtn = paginationEl.querySelector('.next-btn');
            // Click event for page numbers using event delegation
            paginationEl.addEventListener('click', (event) => {
              const target = event.target;
              if (target.classList.contains('pages')) {
                const pageNumber = parseInt(target.textContent, 10);
                if (!isNaN(pageNumber) && pageNumber !== currentPage) {
                  currentPage = pageNumber;
                  renderReviews(data);
                  renderPagination(data);
                }
              }
            });
            prevBtn.addEventListener('click', () => {
              if (currentPage > 1) {
                currentPage--;
                renderReviews(data);
                renderPagination(data);
              }
            });
            nextBtn.addEventListener('click', () => {
              if (currentPage < totalPages) {
                currentPage++;
                renderReviews(data);
                renderPagination(data);
              }
            });
          }
        
          fetch(`${url}&limit=${limit}`)
            .then(response => response.json())
            .then(data => {
              renderReviews(data);
              renderPagination(data);
            })
            .catch(error => console.error(error));
        }







// select box 

document.addEventListener("DOMContentLoaded", function() {
  // Wait for the page to fully load

  var firstSelectBox = document.querySelector('select[name="pet-number"]');
  var secondSelectBox = document.querySelector('select[name="options[Number of Pets]"]');

  // Check if both select boxes are available on the page
  if (firstSelectBox && secondSelectBox) {
    // Add an event listener to the first select box
    firstSelectBox.addEventListener("change", function() {
      // Set the value of the second select box to match the first select box
      secondSelectBox.value = firstSelectBox.value;
    });
  }
});


// page data 
function createTableOfContents() {
  // Find all the headings in the document
  const headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");
  
  // Create a new unordered list to hold the table of contents
  const tocList = document.createElement("ul");

  // Loop through the headings and create a new list item for each one
  for (let i = 0; i < headings.length; i++) {
    const heading = headings[i];
    
    // Skip any headings without an ID attribute
    if (!heading.id) {
      continue;
    }

    // Create a new list item with a link to the heading
    const listItem = document.createElement("li");
    const link = document.createElement("a");
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    listItem.appendChild(link);
    
    // Add the list item to the table of contents
    tocList.appendChild(listItem);
  }

  // Add the table of contents to the document
  const tocContainer = document.createElement("div");
  tocContainer.classList.add("table-of-contents");
  const tocHeading = document.createElement("h2");
  tocHeading.textContent = "Table of Contents";
  tocContainer.appendChild(tocHeading);
  tocContainer.appendChild(tocList);
  document.body.insertBefore(tocContainer, document.body.firstChild);
}





// Function to extract and update the currency symbol
function updateButtonInnerPrice() {
    // add to cart button price 
    var priceElement = document.querySelector(".product__info-wrapper .price__container .price__regular .price-item--regular"); 
    // Find the element with class "button_inner_price"
    var buttonInnerPriceElement = document.querySelector(".product__info-wrapper  .button_inner_price");

    if (priceElement && buttonInnerPriceElement) {
        // Get the text content of the "money" span
        var moneyElement = priceElement.querySelector(".money");
        if (moneyElement) {
            var moneyText = moneyElement.textContent;
            
            // Extract the currency symbol (e.g., £) by splitting on space
            var currencySymbol = moneyText.split(" ")[0];
            
            // Update the text of the "button_inner_price" span with the currency symbol
            buttonInnerPriceElement.textContent = currencySymbol;
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    setInterval(updateButtonInnerPrice, 1000);
});
 